var Typography;
(function (Typography) {
  /**
   * @deprecated use Marketing titles or {@link Typography.DISPLAY_LARGE} instead
   */
  Typography["DISPLAY_EXTRA_LARGE"] = "display-extra-large";
  Typography["DISPLAY_LARGE"] = "display-large";
  Typography["DISPLAY_MEDIUM"] = "display-medium";
  Typography["DISPLAY_SMALL"] = "display-small";
  Typography["DISPLAY_NUMBER"] = "display-number";
  Typography["TITLE_SCREEN"] = "title-screen";
  Typography["TITLE_SECTION"] = "title-section";
  Typography["TITLE_SUBSECTION"] = "title-subsection";
  Typography["TITLE_BODY"] = "title-body";
  Typography["TITLE_GROUP"] = "title-group";
  Typography["BODY_LARGE"] = "body-large";
  Typography["BODY_DEFAULT"] = "body-default";
  Typography["BODY_DEFAULT_BOLD"] = "body-default-bold";
  Typography["BODY_LARGE_BOLD"] = "body-large-bold";
  Typography["LINK_LARGE"] = "link-large";
  Typography["LINK_DEFAULT"] = "link-default";
})(Typography || (Typography = {}));

export { Typography };
//# sourceMappingURL=typography.mjs.map
